export const SCOPE = 'scope:dashboards';

export const DASHABORDS = `${SCOPE}/DASHABORDS`;
